module.exports = __webpack_public_path__ + "static/media/notification-white.183e47a7.svg";